import { environment } from '../constants/commonConstant';
var graphApiSelectors = 'country,officeLocation,preferredDataLocation,usageLocation,userPrincipalName,givenName,surname,id';
export var getConfig = function (env) {
    switch (env) {
        case environment.PPE:
        case environment.RING_0:
        case environment.RING_1:
            return {
                msalAuthorityUrl: 'https://login.microsoftonline.com/',
                tenantId: '72f988bf-86f1-41af-91ab-2d7cd011db47',
                resourceUrl: 'https://microsoft.onmicrosoft.com/smartParkingAPINonProd/.default',
                graphEndpoint: "https://graph.microsoft.com/v1.0/me?$select=".concat(graphApiSelectors),
                smartParkingApimKey: '498bdbd4c827425fadf6e32266b3e2d8;product=smart-parking',
                smartParkingApimBaseUrl: 'https://dwp-nonprod.azure-api.net',
                usersGraphEndpoint: 'https://graph.microsoft.com/v1.0/users',
            };
        case environment.RING_2:
        case environment.RING_3:
        case environment.RING_4:
        case environment.PROD:
            return {
                msalAuthorityUrl: 'https://login.microsoftonline.com/',
                tenantId: '72f988bf-86f1-41af-91ab-2d7cd011db47',
                resourceUrl: 'https://microsoft.onmicrosoft.com/smartParkingAPI/.default',
                graphEndpoint: "https://graph.microsoft.com/v1.0/me?$select=".concat(graphApiSelectors),
                smartParkingApimKey: '347ff7db663c4de5bd134bb994f19b38;product=smart-parking',
                smartParkingApimBaseUrl: 'https://dwp.azure-api.net',
                usersGraphEndpoint: 'https://graph.microsoft.com/v1.0/users',
            };
        default:
            return {
                msalAuthorityUrl: '',
                tenantId: '',
                resourceUrl: '',
                graphEndpoint: '',
                smartParkingApimKey: '',
                smartParkingApimBaseUrl: '',
                usersGraphEndpoint: '',
            };
    }
};
